
export default function About() {
  return (
    <section id="about" className="py-32 bg-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Content */}
          <div>
            {/* Section Badge */}
            <div className="inline-flex items-center gap-2 mb-6 bg-blue-500/10 border border-blue-500/20 px-5 py-2 rounded-full">
              <div className="w-2 h-2 bg-blue-600 rounded-full" />
              <span className="text-blue-700 font-semibold text-sm tracking-wider uppercase">About Madina Associates</span>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
              Your Trusted Partner in{' '}
              <span className="bg-gradient-to-r from-red-600 to-blue-600 bg-clip-text text-transparent">
                Real Estate Excellence
              </span>
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Madina Associates has been at the forefront of property dealing and construction services for over 15 years. We specialize in creating exceptional living spaces and commercial properties that stand the test of time.
            </p>
            
            <p className="text-lg text-gray-600 mb-12 leading-relaxed">
              Our commitment to quality, transparency, and customer satisfaction has made us one of the most trusted names in the real estate and construction industry. From land acquisition to project completion, we handle every aspect with precision and care.
            </p>

            {/* Feature Grid */}
            <div className="grid sm:grid-cols-2 gap-6 mb-10">
              <div className="group flex items-start gap-4 p-5 rounded-2xl bg-white border border-gray-100 hover:border-blue-500/30 hover:shadow-xl transition-all duration-300 cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-red-500 to-blue-600 rounded-xl flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">Trusted Expertise</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">Proven track record of successful projects and satisfied clients</p>
                </div>
              </div>

              <div className="group flex items-start gap-4 p-5 rounded-2xl bg-white border border-gray-100 hover:border-blue-500/30 hover:shadow-xl transition-all duration-300 cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-red-500 to-blue-600 rounded-xl flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">Quality Assurance</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">Commitment to excellence in every aspect of our work</p>
                </div>
              </div>

              <div className="group flex items-start gap-4 p-5 rounded-2xl bg-white border border-gray-100 hover:border-blue-500/30 hover:shadow-xl transition-all duration-300 cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-red-500 to-blue-600 rounded-xl flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-team-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">Professional Team</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">Experienced professionals dedicated to your success</p>
                </div>
              </div>

              <div className="group flex items-start gap-4 p-5 rounded-2xl bg-white border border-gray-100 hover:border-blue-500/30 hover:shadow-xl transition-all duration-300 cursor-pointer">
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-red-500 to-blue-600 rounded-xl flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-customer-service-2-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2 text-lg">Client-Focused</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">Your satisfaction is our top priority</p>
                </div>
              </div>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20corporate%20real%20estate%20office%20interior%20with%20modern%20design%2C%20elegant%20business%20meeting%20space%20featuring%20sophisticated%20furniture%20and%20premium%20finishes%2C%20warm%20ambient%20lighting%20creating%20professional%20atmosphere%2C%20contemporary%20architecture%20with%20glass%20and%20wood%20elements%2C%20luxury%20property%20development%20company%20headquarters%20showcasing%20success%20and%20professionalism&width=800&height=1000&seq=about-madina-office&orientation=portrait"
                alt="Madina Associates Office"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
            
            {/* Floating Stats Card */}
            <div className="absolute -bottom-10 -left-10 bg-gradient-to-br from-red-600 to-blue-600 text-white p-10 rounded-3xl shadow-2xl max-w-xs hover:scale-105 transition-transform duration-300 cursor-pointer">
              <div className="text-6xl font-bold mb-3">15+</div>
              <div className="text-xl font-semibold leading-tight">Years of Excellence in Real Estate</div>
            </div>

            {/* Decorative Dots */}
            <div className="absolute -top-6 -right-6 w-24 h-24 grid grid-cols-4 gap-2 opacity-20">
              {[...Array(16)].map((_, i) => (
                <div key={i} className="w-2 h-2 bg-blue-500 rounded-full" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
